import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Popup from '@atlaskit/popup';
import { Pressable } from '@atlaskit/primitives/compiled';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from '../../messages';
import OrgSwitcher from '../index';

const styles = cssMap({
	orgSwitcherButton: {
		width: '32px',
		height: '32px',
		// TODO: Remove this once we have icon support
		backgroundColor: token('color.background.accent.red.bolder'),
		borderRadius: token('radius.large'),
	},
	headerContainer: {
		paddingTop: token('space.150'),
		width: '32px',
	},
});

export type OrgSwitcherPopupProps = {
	isOpen: boolean;
	onClose: () => void;
	onOpen: () => void;
};

export function OrgSwitcherPopup({
	isOpen,
	onClose,
	onOpen,
}: OrgSwitcherPopupProps): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.headerContainer}>
			<Popup
				placement="right"
				offset={[0, 20]}
				isOpen={isOpen}
				onClose={onClose}
				content={() => (
					<OrgSwitcher
						currentOrgId="org-1"
						title="Org Switcher"
						currentUnitId="unit-1"
						orgs={[
							{
								id: 'org-1',
								name: 'Org 1',
								units: [{ id: 'unit-1', name: 'Unit 1' }],
							},
						]}
					/>
				)}
				trigger={(triggerProps) => (
					<Pressable
						{...triggerProps}
						aria-label={formatMessage(messages.exampleSwitcherText)}
						onClick={onOpen}
						testId="navigation-ribbon--org-switcher-button"
						xcss={styles.orgSwitcherButton}
					/>
				)}
				shouldRenderToParent
			/>
		</Box>
	);
}
